import React, { useState, useRef, useEffect } from "react";

export default function CustomDatePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(new Date());
  const ref = useRef();

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();

  const handleSelect = (day) => {
    const selected = new Date(current.getFullYear(), current.getMonth(), day);
    onChange?.(selected);
    setOpen(false);
  };

  const renderDays = () => {
    const year = current.getFullYear();
    const month = current.getMonth();
    const total = daysInMonth(year, month);

    const firstDay = new Date(year, month, 1).getDay();
    const blanks = Array(firstDay).fill(null);
    const days = Array.from({ length: total }, (_, i) => i + 1);

    return [...blanks, ...days];
  };

  return (
    <div className="relative w-full" ref={ref}>
      <input
        readOnly
        onClick={() => setOpen(!open)}
        value={value ? value.toLocaleDateString("en-GB") : ""}
        placeholder="dd-mm-yyyy"
        className="w-full p-2 border rounded cursor-pointer"
      />

      {open && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-white shadow-lg border rounded-lg p-3 z-50">

          {/* Header */}
          <div className="flex justify-between items-center">
            <button
              className="px-2 py-1 hover:bg-gray-200 rounded"
              onClick={() =>
                setCurrent(new Date(current.getFullYear(), current.getMonth() - 1, 1))
              }
            >
              ◄
            </button>

            <h2 className="font-semibold">
              {current.toLocaleString("default", { month: "long" })} {current.getFullYear()}
            </h2>

            <button
              className="px-2 py-1 hover:bg-gray-200 rounded"
              onClick={() =>
                setCurrent(new Date(current.getFullYear(), current.getMonth() + 1, 1))
              }
            >
              ►
            </button>
          </div>

          {/* Week Days */}
          <div className="grid grid-cols-7 text-center mt-3 font-semibold text-sm">
            {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
              <div key={d}>{d}</div>
            ))}
          </div>

          {/* Days */}
          <div className="grid grid-cols-7 gap-1 text-center mt-2">
            {renderDays().map((day, idx) => {
              const isSelected =
                day &&
                value &&
                value.getDate() === day &&
                value.getMonth() === current.getMonth() &&
                value.getFullYear() === current.getFullYear();

              return (
                <div
                  key={idx}
                  onClick={() => day && handleSelect(day)}
                  className={`p-2 rounded cursor-pointer text-sm  
                    ${day ? "hover:bg-blue-100" : ""}
                    ${isSelected ? "bg-blue-500 text-white hover:bg-blue-600" : ""}
                  `}
                >
                  {day || ""}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
